import React from "react";
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";

import {Box} from "@mui/material";

import SectionHeader from "components/dashboard/SectionHeader";
import MobileCarousel from "components/MobileCarousel";

import TurnoverGraph from "./components/TurnoverGraph";
import VolumeGraph from "./components/VolumeGraph";

import {UserAgentUtils} from "utils/useragent";

function SaleValuesAndVolume({ ordersData, loading, unit, unitParser, unitTooltip, currency }) {
    const online = ordersData?.online ?? {};
    const physical = ordersData?.physical ?? {};

    // Order count across all statuses
    const onlineCountTotal = online.countTotal ?? 0;

    return (
        <Box>
            <SectionHeader
                title={<FormattedMessage id="dashboard.saleValuesAndVolume.title" />}
                subtitle={<FormattedMessage id="dashboard.saleValuesAndVolume.subtitle" />}
            />
            <Box sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                gap: 2,
                mt: 2
            }}>
                {UserAgentUtils.isMobile() ? (
                    <MobileCarousel>
                        <TurnoverGraph
                            online={online}
                            physical={physical}
                            onlineCountTotal={onlineCountTotal}
                            unit={unit}
                            unitParser={unitParser}
                            unitTooltip={unitTooltip}
                            loading={loading}
                            currency={currency}
                        />
                        <VolumeGraph
                            online={online}
                            physical={physical}
                            onlineCountTotal={onlineCountTotal}
                            ordersData={ordersData}
                            unit={unit}
                            unitParser={unitParser}
                            unitTooltip={unitTooltip}
                            loading={loading}
                        />
                    </MobileCarousel>
                ) : (
                    <>
                        <TurnoverGraph
                            online={online}
                            physical={physical}
                            onlineCountTotal={onlineCountTotal}
                            unit={unit}
                            unitParser={unitParser}
                            unitTooltip={unitTooltip}
                            loading={loading}
                            currency={currency}
                        />
                        <VolumeGraph
                            online={online}
                            physical={physical}
                            onlineCountTotal={onlineCountTotal}
                            ordersData={ordersData}
                            unit={unit}
                            unitParser={unitParser}
                            unitTooltip={unitTooltip}
                            loading={loading}
                        />
                    </>
                )}
            </Box>
        </Box>
    );
}

SaleValuesAndVolume.propTypes = {
    ordersData: PropTypes.object,
    loading: PropTypes.bool,
    unit: PropTypes.oneOf(["day", "month", "year"]).isRequired,
    unitParser: PropTypes.oneOf(["YYYY", "YYYYMM", "YYYYMMDD"]).isRequired,
    unitTooltip: PropTypes.oneOf(["YYYY", "MMMM YYYY", "D MMMM YYYY"]).isRequired,
    currency: PropTypes.string,
};

export default SaleValuesAndVolume;
